import { parseShippingMethods } from './dates';

const hasLegacyShipping = publicData => {
  if (!publicData || typeof publicData !== 'object') return false;
  const one = publicData.shippingPriceInSubunitsOneItem;
  const add = publicData.shippingPriceInSubunitsAdditionalItems;
  return (
    (typeof one === 'number' && !isNaN(one)) || (typeof add === 'number' && !isNaN(add))
  );
};

/**
 * Builds orderData for addToCart so checkout receives deliveryMethod / shippingMethodId,
 * matching ProductOrderForm defaults (bundle → panier → checkout).
 *
 * @param {Object} listing - SDK listing
 * @param {number} quantity - line quantity
 * @returns {{ quantity: number, deliveryMethod?: string, shippingMethodId?: string }}
 */
export const buildCartOrderDataForListing = (listing, quantity) => {
  const qty = Number(quantity) > 0 ? Number(quantity) : 1;
  const base = { quantity: qty };
  const publicData = listing?.attributes?.publicData || {};
  const pickupEnabled = !!publicData.pickupEnabled;
  const shippingEnabled = !!publicData.shippingEnabled;
  const shippingMethods = parseShippingMethods(publicData.shippingMethods);
  const legacyShipping = hasLegacyShipping(publicData);
  const hasShippableConfig = shippingMethods.length > 0 || legacyShipping;

  const shippingPayload = () => {
    const shippingMethodId =
      shippingMethods.length > 0
        ? shippingMethods[0]?.id
        : undefined;
    return {
      ...base,
      deliveryMethod: 'shipping',
      ...(shippingMethodId ? { shippingMethodId } : {}),
    };
  };

  // Same priority as ProductOrderForm initial deliveryMethodMaybe
  if (shippingEnabled && pickupEnabled) {
    return shippingPayload();
  }
  if (shippingEnabled && !pickupEnabled) {
    return shippingPayload();
  }
  if (!shippingEnabled && pickupEnabled) {
    return { ...base, deliveryMethod: 'pickup' };
  }

  // Flags absents / faux : déduire depuis la config livraison (méthodes ou legacy)
  if (hasShippableConfig) {
    return shippingPayload();
  }

  if (pickupEnabled) {
    return { ...base, deliveryMethod: 'pickup' };
  }

  return base;
};
